import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Blog, BlogGridsTitle } from "../../../../constants";
import BlogBoxSingle from "./BlogBoxSingle";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const BlogSingleContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BlogGridsTitle} parent={Blog} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <BlogBoxSingle />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BlogSingleContainer;
